var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 45C63 54.9412 54.9411 63 45 63C35.0589 63 27 54.9412 27 45C27 35.0588 35.0589 27 45 27C54.9411 27 63 35.0588 63 45ZM45 33.5455C44.0963 33.5455 43.3636 34.2782 43.3636 35.1818V48.2727C43.3636 49.1763 44.0963 49.9091 45 49.9091C45.9037 49.9091 46.6364 49.1763 46.6364 48.2727V35.1818C46.6364 34.2782 45.9037 33.5455 45 33.5455ZM45 56.8636C46.1297 56.8636 47.0455 55.9479 47.0455 54.8182C47.0455 53.6884 46.1297 52.7727 45 52.7727C43.8703 52.7727 42.9545 53.6884 42.9545 54.8182C42.9545 55.9479 43.8703 56.8636 45 56.8636Z",
    fill: "#DC6803"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "#FFFAEB",
    strokeWidth: 12.6667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.086c3bed7d6c13d91c27f587dec1cd8b.svg";
export { ForwardRef as ReactComponent };